import browseIcon from '../assets/img/browse-files.svg';
import UploadingIcon from '../assets/img/uploading.gif';
import { useEffect, useState } from 'react';
import {
  AiFillCheckCircle,
  AiOutlineCloseCircle,
  AiOutlineClose,
  AiOutlineCloudUpload,
  AiOutlineMinusSquare,
  AiOutlineExpandAlt,
} from 'react-icons/ai/index.js';
import axios, { CancelTokenSource } from 'axios';
import {
  bytesToSize,
  Modal,
  FileUpload,
  FileWithExtraProps,
  Pagination,
} from '@ssar-app/uikit';
import {
  Button,
  Flex,
  Icon,
  Image,
  Progress,
  Text,
  Tooltip,
  Center,
  Alert,
} from '@chakra-ui/react';

interface UploadFormProps {
  getUploadStatus?: (
    formData: FormData,
    cancelTokenSource: CancelTokenSource,
    addedFile: FileWithExtraProps,
    setFilesUploadPercentage: (
      value: React.SetStateAction<FileWithExtraProps[]>,
    ) => void,
  ) => void;
}

export const UploadForm = (props: UploadFormProps) => {
  const { getUploadStatus } = props;

  const [minimizedModal, setMinimizedModal] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [cancelTokensSource, setCancelTokensSource] = useState<{
    [key: string]: CancelTokenSource;
  }>({});
  const [files, setFiles] = useState<FileWithExtraProps[]>([]);
  const [totalSize, setTotalSize] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const { Dragger } = FileUpload;
  const filesLength = files ? files.length : 0;

  const fetchUploadStatus = (uploadedFiles: FileWithExtraProps[]) => {
    uploadedFiles.map((addedFile) => {
      const formData = new FormData();
      formData.append('files', addedFile);
      // eslint-disable-next-line import/no-named-as-default-member
      const cancelTokenSource = axios.CancelToken.source();
      setCancelTokensSource((tokensSource) => {
        return {
          ...tokensSource,
          [addedFile.uid || '']: cancelTokenSource,
        };
      });

      getUploadStatus &&
        getUploadStatus(formData, cancelTokenSource, addedFile, setFiles);
    });
  };

  const removeFile = (uid: string) => {
    cancelTokensSource && cancelTokensSource[uid].cancel();
    setFiles && setFiles((files) => files.filter((file) => file.uid !== uid));
  };
  useEffect(() => {
    let total = 0;
    files.map((file) => {
      total += file.size || 0;
    });
    setTotalSize(total);
  }, [files]);
  const minimizeModalCheck = () => {
    const length = files.filter((file) => (file.percent || 0) < 100).length;
    return length;
  };
  useEffect(() => {
    if (minimizedModal) {
      const length = minimizeModalCheck();
      if (length === 0) {
        // setFiles([]);
        setMinimizedModal(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [files]);

  return (
    <>
      <Button
        onClick={() => setShowUploadModal(true)}
        variant='solid'
        gap={2}
        ml='auto'
        colorScheme={'blue'}
        size={'sm'}
      >
        <AiOutlineCloudUpload /> Upload Files
      </Button>
      {minimizedModal && (
        <Alert
          bg='white'
          position='fixed'
          bottom='0'
          right='0'
          w='xs'
          h='48px'
          pl='unset'
          boxShadow='0px 2px 12px 0px #0000001F'
          borderRadius={4}
          zIndex='9999'
        >
          <Image src={UploadingIcon} w='52px' h='52px' />
          Uploading Files
          <Icon
            as={AiOutlineExpandAlt}
            ml='auto'
            fontSize='md'
            onClick={() => {
              setMinimizedModal(false);
              setShowUploadModal(true);
            }}
          />
        </Alert>
      )}
      <Modal
        isOpen={showUploadModal}
        size={filesLength > 0 ? '3xl' : '5xl'}
        // eslint-disable-next-line jsx-a11y/no-autofocus
        autoFocus={false}
        onClose={() => {
          if (minimizeModalCheck() !== 0) {
            setMinimizedModal(true);
          }
          setShowUploadModal(false);
        }}
        showCloseButton={false}
        header={
          <Flex alignItems='center'>
            UPLOAD FILES
            <Flex ml='auto' alignItems='center' gap={3}>
              <Icon
                as={AiOutlineMinusSquare}
                onClick={() => {
                  if (minimizeModalCheck() !== 0) {
                    setMinimizedModal(true);
                  }
                  setShowUploadModal(false);
                }}
              />
              <Icon
                as={AiOutlineClose}
                onClick={() => {
                  cancelTokensSource &&
                    Object.keys(cancelTokensSource).map((uid) =>
                      cancelTokensSource[uid].cancel(),
                    );
                  setShowUploadModal(false);
                  if (minimizeModalCheck() !== 0) {
                    setMinimizedModal(true);
                  }
                  setFiles && setFiles([]);
                }}
              />
            </Flex>
          </Flex>
        }
        headerProps={{ fontWeight: 400, color: '#3C414F' }}
        footer={
          <Button
            variant='outline'
            colorScheme='gray'
            py={3}
            gap={1}
            h={12}
            onClick={() => {
              cancelTokensSource &&
                Object.keys(cancelTokensSource).map((uid) =>
                  cancelTokensSource[uid].cancel(),
                );
              setFiles && setFiles([]);
            }}
            disabled={
              filesLength === 0 ||
              files.filter((file) => (file?.percent || 0) < 100).length === 0
            }
            _focus={{ boxShadow: 'unset' }}
          >
            <AiOutlineClose /> Cancel all uploads
          </Button>
        }
      >
        <Dragger
          fileProps={{ multiple: true }}
          containerProps={{
            boxShadow: '0px 6px 35px 0px #9aa1ab26',
            background: 'white',
            padding: filesLength > 0 ? '12px' : '24px',
            display: filesLength > 0 ? 'flex' : 'grid',
            gap: filesLength > 0 ? '40px' : '12px',
            textAlign: 'center',
            borderWidth: '1px',
            borderStyle: 'dashed',
            borderColor: '#A66CAD',
            alignItems: 'center',
          }}
          onFilesAdded={fetchUploadStatus}
          // itemRender={() => undefined}
          // listType='text'
          files={files}
          onChange={(files) => {
            setFiles && setFiles(files);
          }}
          // accept='.csv'
        >
          {filesLength > 0 ? (
            <Icon as={AiOutlineCloudUpload} color='#828283' fontSize={40} />
          ) : (
            <Center>
              <Icon as={AiOutlineCloudUpload} color='#828283' fontSize={50} />
            </Center>
          )}

          <Text>Drag or drag file to this area to start file upload.</Text>
          <Text>or</Text>
          <Button
            h='12'
            variant='outline'
            borderWidth={1}
            borderStyle='solid'
            color='#A45DAD'
            _focus={{ boxShadow: 'unset' }}
            m={filesLength > 0 ? '' : '0 auto'}
          >
            <Image src={browseIcon} mr='2' />
            Browse Files
          </Button>
        </Dragger>
        {files && filesLength > 0 && (
          <>
            <Flex mt={6} mb={4} color='#6C757D'>
              <Text fontSize={16}>Selected Files</Text>
              <Text ml='auto' mr={4}>
                Total Size:{' '}
              </Text>
              <Text>{bytesToSize(totalSize)}</Text>
            </Flex>
            {files
              .slice((currentPage - 1) * pageSize, currentPage * pageSize)
              .map((file, index) => (
                <Flex
                  key={index}
                  p={4}
                  my={2}
                  borderRadius='base'
                  border={'1px solid #E9ECF1'}
                >
                  <span style={{ width: '95%' }}>
                    <Text fontWeight={'bold'}>{file.name || ''}</Text>
                    <Flex>
                      <span>{bytesToSize(file.size || 0)}</span>
                      <Text ml='auto'>{file.percent}%</Text>
                    </Flex>
                    <Progress
                      size='sm'
                      value={file.percent}
                      colorScheme='raspberry'
                    />
                  </span>
                  {file.percent === 100 ? (
                    <Tooltip label='Uploaded'>
                      <Icon
                        as={AiFillCheckCircle}
                        w={4}
                        h={4}
                        cursor='pointer'
                        ml='auto'
                        my='auto'
                        color='#52c41a'
                      />
                    </Tooltip>
                  ) : (
                    <Icon
                      as={AiOutlineCloseCircle}
                      w={4}
                      h={4}
                      cursor='pointer'
                      ml='auto'
                      my='auto'
                      onClick={() => removeFile(file.uid || '')}
                    />
                  )}
                </Flex>
              ))}
            <Flex mt={3}>
              <Pagination
                current={currentPage}
                total={filesLength}
                defaultPageSize={5}
                pageSize={pageSize}
                pageSizeOptions={[5, 10, 20, 50, 100]}
                onChange={(page) => {
                  setCurrentPage(page);
                }}
                onShowSizeChange={(page, pageSize) => {
                  setCurrentPage(page);
                  setPageSize(pageSize);
                }}
                showSizeChanger
                showTotal={(total, range) =>
                  `${range[0]}-${range[1]} of ${total} items`
                }
              />
            </Flex>
          </>
        )}
      </Modal>
    </>
  );
};
